import { Link } from "react-router-dom";
import "./terminosycondiciones.css";

function TerminosYCondiciones() {
  return (
    <div className="container my-5">
      {/* Título principal */}
      <h1 className="text-center mb-3">Términos y Condiciones</h1>
      <p className="text-center text-muted mb-5">Última actualización: [03/12/2025]</p>

      {/* Contenido de los términos */}
      <p>
        Al acceder y utilizar la plataforma de <strong>Working Unidos</strong>, aceptas estar sujeto a los 
        siguientes términos y condiciones. Este documento establece los derechos y obligaciones entre 
        Working Unidos y sus usuarios, ya sean individuos o empleadores, y aplica tanto a nivel nacional 
        en los Estados Unidos como a nivel internacional.
      </p>

      <h2 className="h4 mt-4">1. Aceptación de los Términos</h2>
      <p>
        Al registrarte, acceder o usar cualquier parte de Working Unidos, confirmas que has leído, entendido 
        y aceptado estos Términos y Condiciones. Si no estás de acuerdo con estos términos, debes abstenerte 
        de utilizar nuestros servicios.
      </p>

      <h2 className="h4 mt-4">2. Definiciones</h2>
      <ul className="ms-4">
        <li>
          <strong>Plataforma:</strong> El sitio web de Working Unidos y los servicios asociados, 
          incluyendo las cuentas de usuario y empleadores.
        </li>
        <li>
          <strong>Usuario:</strong> Individuos que se registran para buscar oportunidades laborales, 
          coaching, orientación educativa y recursos migratorios.
        </li>
        <li>
          <strong>Empleador:</strong> Empresas o individuos que se registran para publicar empleos y 
          gestionar candidatos.
        </li>
        <li>
          <strong>Servicios:</strong> Recursos, funcionalidades, suscripciones y productos ofrecidos 
          por Working Unidos.
        </li>
        <li>
          <strong>Suscripción:</strong> Planes de pago ofrecidos a usuarios y empleadores para acceder 
          a servicios adicionales.
        </li>
      </ul>

      <h2 className="h4 mt-4">3. Uso de la Plataforma</h2>

      <h3 className="h5 mt-3">3.1. Elegibilidad</h3>
      <p>Para registrarte y utilizar Working Unidos, debes:</p>
      <ul className="ms-4">
        <li>Ser mayor de 18 años.</li>
        <li>Proporcionar información precisa y veraz en el formulario de registro.</li>
        <li>Cumplir con todas las leyes y regulaciones aplicables en tu jurisdicción.</li>
      </ul>

      <h3 className="h5 mt-3">3.2. Registro de Cuentas</h3>
      <ul className="ms-4">
        <li>
          <strong>Usuario:</strong> Debes crear una cuenta con un correo electrónico válido y una 
          contraseña segura. No debes compartir tu cuenta con terceros.
        </li>
        <li>
          <strong>Empleador:</strong> Las empresas deben proporcionar información veraz sobre su 
          identidad y su naturaleza comercial.
        </li>
        <li>
          Eres responsable de mantener la confidencialidad de tu cuenta y contraseña, y de cualquier 
          actividad que ocurra bajo tu cuenta.
        </li>
      </ul>

      <h3 className="h5 mt-3">3.3. Prohibiciones</h3>
      <p>Al utilizar Working Unidos, te comprometes a no:</p>
      <ul className="ms-4">
        <li>Usar la plataforma para fines ilegales o no autorizados.</li>
        <li>Suplantar la identidad de otra persona o entidad.</li>
        <li>Distribuir virus o cualquier otra tecnología dañina.</li>
        <li>Extraer datos de manera automatizada sin nuestro consentimiento.</li>
        <li>Realizar actividades que perjudiquen el buen funcionamiento de la plataforma.</li>
      </ul>

      <h2 className="h4 mt-4">4. Suscripciones y Pagos</h2>

      <h3 className="h5 mt-3">4.1. Tipos de suscripciones</h3>
      <p>
        Working Unidos ofrece planes de suscripción para usuarios y empleadores. Cada plan tiene características 
        y beneficios específicos que se detallan en la plataforma.
      </p>

      <h3 className="h5 mt-3">4.2. Procesamiento de pagos</h3>
      <ul className="ms-4">
        <li>
          Los pagos deben realizarse a través de los métodos aceptados (tarjeta de crédito/débito, 
          PayPal, Google Pay, Apple Pay).
        </li>
        <li>
          Los precios están en dólares estadounidenses (USD) y pueden incluir impuestos según corresponda.
        </li>
        <li>
          Al suscribirte, autorizas a Working Unidos a cobrar automáticamente las renovaciones, a menos 
          que canceles antes del próximo período de facturación.
        </li>
      </ul>

      <h3 className="h5 mt-3">4.3. Renovación y cancelación de suscripciones</h3>
      <ul className="ms-4">
        <li>
          Las suscripciones se renovarán automáticamente a menos que canceles antes del próximo período 
          de renovación.
        </li>
        <li>
          Puedes cancelar en cualquier momento desde tu cuenta. La cancelación no da derecho a reembolsos 
          por pagos ya efectuados.
        </li>
      </ul>

      <h2 className="h4 mt-4">5. Publicación de Empleos (para Empleadores)</h2>

      <h3 className="h5 mt-3">5.1. Reglas para publicar empleos</h3>
      <ul className="ms-4">
        <li>
          Los empleadores deben proporcionar información precisa y veraz en las ofertas de empleo.
        </li>
        <li>
          No se permite publicar ofertas engañosas, discriminatorias o ilegales.
        </li>
        <li>
          Working Unidos se reserva el derecho de eliminar ofertas que violen estos términos.
        </li>
      </ul>

      <h3 className="h5 mt-3">5.2. Visibilidad de empleos</h3>
      <ul className="ms-4">
        <li>
          Los empleadores con suscripciones premium pueden mejorar la visibilidad de sus ofertas de empleo 
          mediante opciones destacadas.
        </li>
        <li>
          Working Unidos no garantiza aplicaciones o la idoneidad de los candidatos para las ofertas publicadas.
        </li>
      </ul>

      {/* Disclaimer / Contacto */}
      <p className="mt-4 pt-3 border-top">
        Si tienes alguna pregunta o duda sobre estos Términos y Condiciones, contáctanos a través de 
        <a href="mailto:info@workingunidos.com"> info@workingunidos.com</a>.
      </p>

      {/* Botón de regresar */}
      <div className="text-center mt-4">
        <Link to="/register" className="register-btn">
          Regresar
        </Link>
      </div>
    </div>
  );
}

export default TerminosYCondiciones;